import * as React from 'react';
import './ReturnsRmaModal.scss';
import Modal from 'src/components/common/Modal';
import { RMA_EDIT, IRmaModalData, RMA_SUBMIT } from '../../ReturnsView';
import ReturnsRmaTable from './components/ReturnsRmaTable';
import ShippingOptions from '../ReturnsCartModal/components/ShippingOptions';
import DistributionOptions from '../ReturnsCartModal/components/DistributionOptions';
// import BoxInfo from './components/BoxInfo';
import BoxInfo from '../ReturnsCartModal/components/BoxInfo';
import DropOffStore from '../ReturnsCartModal/components/DropOffStore';
import SelfShipping from '../ReturnsCartModal/components/SelfShipping';
import BoxConfirm from '../ReturnsCartModal/components/BoxConfirm';
import Button from 'src/components/common/Button';
import {
  IReturnDetail,
  IReturnSubmittedOption,
  IReturnEditedOption,
  IStatusFilter,
  IReturnGenerateShippingLabel,
  IReturnGenerateShippingLabelResponse
} from 'src/services/returns/typings';
import hasComma from 'src/utils/hasComma';
import { ERmaStatus } from '../StatusTab/StatusTab';
import Alert from 'src/components/common/Alert';
import cartService from 'src/services/cart/CartService';
import locationServiceInstance from 'src/services/location/LocationService';

interface IReturnsRmaModal {
  closeModal: () => void;
  rmaModalData: IRmaModalData;
  onSubmitAfterEditRmaList: (
    config: IReturnSubmittedOption,
    callback?: () => void
  ) => void;
  onSaveAfterEditRmaList: (
    config: IReturnEditedOption,
    callback?: () => void
  ) => void;
  handleOpenBarcodeModal: (rmaNumber: string,upsResponseData:any[]) => void;
  handleSelectedTypeOfItemEligible: (type: string) => void;
  typeOfItemStatus: string;
  typeOfItemEligible: string;
  filters: {
    status: string;
    search: any;
  };
  getStatusItems: (body?: IStatusFilter) => void;
  clearStatusFilters: () => void;
  clearEligibleFilters: () => void;
  getRMALists: (body?: IStatusFilter) => void;
  selectTab: (index: number) => void;
  userData:any;
  onGenerateShippingLabel: (
    upsRequest: IReturnGenerateShippingLabel,
    callback?: (resUpsCharges: IReturnGenerateShippingLabelResponse) => void
  ) => void;
  t?: any;
  error?: any;
  clearError?: () => void;
}

const styles = {
  width: '85%'
};

const ReturnsRmaModal: React.FC<IReturnsRmaModal> = props => {
  const {
    closeModal,
    rmaModalData,
    onSubmitAfterEditRmaList,
    onSaveAfterEditRmaList,
    handleOpenBarcodeModal,
    handleSelectedTypeOfItemEligible,
    getStatusItems,
    typeOfItemStatus,
    typeOfItemEligible,
    filters,
    clearStatusFilters,
    clearEligibleFilters,
    getRMALists,
    selectTab,
    userData,
    onGenerateShippingLabel,
    t,
    error,
    clearError
  } = props;
  const [poNumber, setPoNumber] = React.useState<string>('');
  const [rmaData, setRmaData] = React.useState<IReturnDetail[]>([]);
  const [deletedItems, setDeletedItems] = React.useState<number[]>([]);
  const [distributionSelectedOption, setDistributionSelectedOption] = React.useState('');
  const [shippingTabToShow,setShippingTabToShow]=React.useState(true);
  const [checkShippingOtiopn,setCheckShippingOption]=React.useState(true);
  const [shippingSelectedOption, setShippingSelectedOption] = React.useState('');
  const [tabBackButtonText,setTabBackButtonText]=React.useState('');
  const [shppingType,setShippingType]=React.useState('');
  const [storeList,setStoreList]=React.useState([]);
  const [isLoader,setIsLoader]=React.useState(false);
  const [confirmBox,setConfirmBox]=React.useState(false);
  const [upsResponseData,setupsResponseData]=React.useState([]);
  const [upsTotalShippingCharge,setupsResponseTotal]=React.useState<number>(0);
  const [submitButtonEnabled,setsubmitButtonEnabled]=React.useState<number>(1);
  const [selfShippingWarehouseCode, setSelfShippingWarehouseCode] = React.useState('');
  const [tabTitle,setTabTitle]=React.useState('Shipping Options');
  const [warehouseCodeVal, setWarehouseCode] = React.useState('');
  const [shppingTypeVal,setShippingTypeVal]=React.useState('');
  const [trackingNumbersVal,setTrackingNumbers]=React.useState([]);
  const [rmaSelected,setRmaSelected]=React.useState('');
  const [preSaveForLaterAlt, setPreSaveForLaterAlt] = React.useState<boolean>(false);
  const [totalItemPrice, setTotalAddedItemPrice] = React.useState<number>(0);
  const [toShippingWarehouseCode, setToShippingWarehouseCode] = React.useState('');
  const [selectedOption, setSelectedOption] = React.useState<string>('');
  const [upsErrorMessage,setUpsErrorMessage]=React.useState('');
  const [shippingLabelRequest, setShippingLabelRequest]=React.useState([]);

  React.useEffect(() => {
    setPoNumber(rmaModalData.poNumber ? rmaModalData.poNumber : '');
    setRmaData(rmaModalData.data.length > 0 ? rmaModalData.data : []);
  }, [rmaModalData]);

  React.useEffect(() => {
    /* Calculate total added item price */
    let totalAddedItemPrice=0;
    rmaData.map((res)=>{
      totalAddedItemPrice=totalAddedItemPrice+res.returnAmount;
    });
    setTotalAddedItemPrice(totalAddedItemPrice);
  }, [rmaData]);

  const handleChangePoNumber = (e: any) => {
    if (!hasComma(e.target.value)) {
      setPoNumber(e.target.value);
    }
  };

  const handleChangeRmaData = (id: number) => {
    setRmaData(rmaData.filter(rma => rma.id !== id));
    setDeletedItems([...deletedItems, id]);
  };

  const handleSubmit = () => {
    let selectedWarehouseCode='';
    if(shppingTypeVal==="DROP_OFF_STORE"){
      selectedWarehouseCode=warehouseCodeVal;
    }else if(shppingTypeVal==="SELF_SHIPPING"){
      selectedWarehouseCode=selfShippingWarehouseCode
    }else if(shppingTypeVal==="PREPAID_SHIPPING"){
      generateShippingLabelNow(shippingLabelRequest);
    }
    if(shppingTypeVal!=="PREPAID_SHIPPING"){
    onSubmitAfterEditRmaList(
      {
        type:'',
        poNumber,
        deletedItems,
        rmaNumber: rmaModalData.rmaNumber,
        items:[],
        submissionType: RMA_SUBMIT,
        shippingType:shppingTypeVal,
        warehouseCode:selectedWarehouseCode,
        trackingNumbers:[]
      },
      () => {
        clearStatusFilters();
        clearEligibleFilters();
        getStatusItems({
          itemType: typeOfItemStatus === 'part' ? 'PART' : 'CORE'
          // rmaListStatus: filters.status,
          // [filters.search && filters.search.searchBy]: filters.search
          //   ? filters.search.query
          //   : undefined
        });
        getRMALists({
          itemType: typeOfItemEligible === 'part' ? 'PART' : 'CORE',
          rmaListStatus: ERmaStatus.NOT_SUBMITTED
        });
        clearError();
        closeModal();
        handleOpenBarcodeModal(rmaModalData.rmaNumber, []);
      }
    );
  }
  };

  const handleSave = () => {
    onSaveAfterEditRmaList(
      {
        deletedItems,
        items: rmaData,
        poNumber,
        rmaNumber: rmaModalData.rmaNumber
      },
      () => {
        getStatusItems({
          itemType: typeOfItemStatus === 'part' ? 'PART' : 'CORE',
          rmaListStatus: filters.status,
          [filters.search && filters.search.searchBy]: filters.search
            ? filters.search.query
            : undefined
        });
        clearEligibleFilters();
        clearError();
        closeModal();
      }
    );
  };

  const isDisabledSubmit = (): boolean => {
    const found = rmaData.findIndex(rma => rma.isValid === false);
    const invalidQty = rmaData.findIndex(rma => rma.returnQuantity === 0);
    return rmaData.length === 0 || found !== -1 || invalidQty !== -1 || submitButtonEnabled===1;
  };

  const isDisabledSave = (): boolean => {
    const found = rmaData.findIndex(rma => rma.isValid === false);
    const invalidQty = rmaData.findIndex(rma => rma.returnQuantity === 0);
    return found !== -1 || invalidQty !== -1;
  };

  const handleChangeRmaDataInput = (value: IReturnDetail[]) => {
    setRmaData(value);
  };

  const handleCloseModal = () => {
    clearError();
    closeModal();
  };

  const handleGenerateShippingLabel = (upsBox:any) => {
    setsubmitButtonEnabled(2);
    setShippingLabelRequest(upsBox);
    setShippingTypeVal('PREPAID_SHIPPING');
  }

   /* Generate Shipping Lable */
   const generateShippingLabelNow = (upsBox:any) => {
    const newUpsBoxWithRmaNumber = upsBox.map((item: any, index: any) => {
      upsBox[index].rmaNumber=rmaModalData.rmaNumber;
      return item;
    });
    onGenerateShippingLabel({
      type: selectedOption,
      items: upsBox
    },
    (resUpsCharges: IReturnGenerateShippingLabelResponse) => {
      // Generate Shipping Lable Response
      if (resUpsCharges.message !== null) {
        setConfirmBox(false);
        setIsLoader(false);
        closeModal();
        // handleOpenBarcodeModal(rmaModalData.rmaNumber, []);
      }else{
        setConfirmBox(false);

      /* Make tracking numbers array */ 
      const warehouseCodeArr: any=[];
      let selectedWarehouseCode='';
      const upsTrakingNoArr: any=[];
      if(resUpsCharges.shippingLabelExtendedInfo.length>0){
        resUpsCharges.shippingLabelExtendedInfo.map((res)=>{
          if(res.trackingNumber!==""){
          upsTrakingNoArr.push(res.trackingNumber);
          }
          if(res.shipToAddress.warehouseCode!==""){
            warehouseCodeArr.push(res.shipToAddress.warehouseCode);
          }
        });
        // setTrackingNumbers(upsTrakingNoArr);
        // setToShippingWarehouseCode(warehouseCodeArr[0]);
        selectedWarehouseCode=warehouseCodeArr[0];
        }
        onSubmitAfterEditRmaList(
          {
            type:'',
            poNumber,
            deletedItems,
            rmaNumber: rmaModalData.rmaNumber,
            items:[],
            submissionType: RMA_SUBMIT,
            shippingType:shppingTypeVal,
            warehouseCode:selectedWarehouseCode,
            trackingNumbers:upsTrakingNoArr
          },
          () => {
            clearStatusFilters();
            clearEligibleFilters();
            getStatusItems({
              itemType: typeOfItemStatus === 'part' ? 'PART' : 'CORE'
              // rmaListStatus: filters.status,
              // [filters.search && filters.search.searchBy]: filters.search
              //   ? filters.search.query
              //   : undefined
            });
            getRMALists({
              itemType: typeOfItemEligible === 'part' ? 'PART' : 'CORE',
              rmaListStatus: ERmaStatus.NOT_SUBMITTED
            });
            clearError();
            closeModal();
          }
        );
        setupsResponseData(resUpsCharges.shippingLabelExtendedInfo);
        handleOpenBarcodeModal(rmaModalData.rmaNumber,resUpsCharges.shippingLabelExtendedInfo);
        setupsResponseTotal(parseFloat(resUpsCharges.total));
        setIsLoader(false);
        setCheckShippingOption(false);
        setShippingSelectedOption('')
        setTabTitle('CONFIRMATION');
        setTabBackButtonText('');
      }
    }
    );
  };

  const getAddresses = async (
    postalCode: string,
    value?: boolean
  ) => {
    const newStoreList: any[] = [];

    newStoreList.push({
      code: '0',
      name: 'Select',
      addr: 'warehouse'
    });

    await locationServiceInstance
      .getLocations(postalCode, value)
      .then(addresses => {
        addresses.forEach((address: any) => {
          newStoreList.push({
            code: address.code,
            name: address.name,
            addr: address.addressLine1
          });
        });
      });

    return newStoreList;
  };

  const getStoreList=async()=>{
    let deliveryAddresses: any[] = [];
    await cartService.getCartShippingAddress().then(async r => {
      deliveryAddresses = await getAddresses(
        r.deliveryLocation.postalCode,
        false
      );
      setStoreList(deliveryAddresses);
      setIsLoader(false);
    });
    
  };

  const handleShippingChangeOption = (e: any) => {
    setShippingSelectedOption(e.target.value);
    
    /* Drop Off at Store Clicked */
    if(e.target.value==="dropOffAtStore"){
      setIsLoader(true);
      setCheckShippingOption(true);
      getStoreList();
      
    }else{
      setCheckShippingOption(false);
      setTabTitle('SHIP TO DISTRIBUTION CENTER ');
      setTabBackButtonText('Back to Shipping Option');
      setShippingType('INDISTRIBUTIONSCREEN');
    }
    
};

const handleDistributionChangeOption = (e: any) => {
  if(e.target.value==="selfShipping"){
    setIsLoader(true);
    getStoreList();
    setWarehouseCode('0');
    setShippingTypeVal('');
    setsubmitButtonEnabled(1);
  }else{
    setSelfShippingWarehouseCode('0');
    setShippingTypeVal('');
    setsubmitButtonEnabled(1);
  }
  setDistributionSelectedOption(e.target.value);
};

const handleBackButtion = () => {
  if(shppingType==="INDISTRIBUTIONSCREEN"){
    /* Back To Shiiping Option */
    setShippingSelectedOption('');
    setDistributionSelectedOption('');
    setCheckShippingOption(true);
    setTabTitle('SHIPPING OPTIONS');
    setTabBackButtonText('');
  }
};

const handleDropOffWarehouse=(dropOffWarehouse:string)=>{
  if(dropOffWarehouse==='0'){
    setsubmitButtonEnabled(1);
  }else{
   setWarehouseCode(dropOffWarehouse);
   setSelfShippingWarehouseCode('0');
   setsubmitButtonEnabled(2);
   setShippingTypeVal('DROP_OFF_STORE');
  }
 }
   
   // Select Self Shipping warehouse
   const handleSelfShippingWarehouse=(selfSAhippingWarehouseCode:any)=>{
    if(selfSAhippingWarehouseCode==='0'){
      setsubmitButtonEnabled(1);
    }else{
    setSelfShippingWarehouseCode(selfSAhippingWarehouseCode);
    setWarehouseCode('0');
    setsubmitButtonEnabled(2);
    setShippingTypeVal('SELF_SHIPPING');
    }
   }
  
  const handleConfirmationCancel=()=>{
    setCheckShippingOption(true);
    setShippingSelectedOption('')
    setTabTitle('CONFIRMATION');
    setTabBackButtonText('');
    setShippingSelectedOption('');
    setDistributionSelectedOption('');
    setTabTitle('SHIPPING OPTIONS');
    setTabBackButtonText('');
    setConfirmBox(false);
    setShippingTypeVal('');
    setupsResponseTotal(0);
  }

  const handleBoxeChange=(e:any)=>{
    if(e===false){
      setsubmitButtonEnabled(1);
    }
  }

  // UPS confirmation 
 const handleUpsConfirmation=()=>{
  setsubmitButtonEnabled(2);
  setSelfShippingWarehouseCode('0');
  setWarehouseCode('0');
  setShippingTypeVal('PREPAID_SHIPPING');
}


  return (
    <div className='shipping-content'>
    <Modal handleCloseModal={closeModal} showClose={false} styles={styles}>
      <>
        {error?.hasError ? (
          <Alert
            styleClass="paymentAlert"
            message={error?.message}
            icon="rpds-error"
            handleCloseAlert={() => {
              props.clearError();
            }}
            type="error"
          />
        ) : (
          ''
        )}
        <div className="rp-returns-rma-modal">
          <div className="rp-returns-rma-modal-header">
            <h3>
              {`${
                rmaModalData.action === RMA_EDIT
                  ? `${t('common.editActionTxt')}`
                  : ''
              } ${t('myReturns.returnNo')} ${rmaModalData.rmaNumber}`}
            </h3>
            <i className="rpds-close" onClick={handleCloseModal} />
          </div>

          <div className="rp-returns-rma-modal-components">
            <ReturnsRmaTable
              rmaData={rmaData}
              rmaDataFixed={rmaModalData.data}
              rmaAction={rmaModalData.action}
              handleChangeRmaData={handleChangeRmaData}
              handleChangeRmaDataInput={handleChangeRmaDataInput}
              handleSelectedTypeOfItemEligible={
                handleSelectedTypeOfItemEligible
              }
              handleCloseModal={handleCloseModal}
              selectTab={selectTab}
              typeOfItemStatus={typeOfItemStatus}
              clearEligibleFilters={clearEligibleFilters}
              getRmaLists={() =>
                getRMALists({
                  itemType: typeOfItemEligible === 'part' ? 'PART' : 'CORE',
                  rmaListStatus: ERmaStatus.NOT_SUBMITTED
                })
              }
              totalShippingCharge={upsTotalShippingCharge}
            />

            <div className="container-fluid">
              <div className="row rp-returns-rma-modal-po-container">
                <div className="col-4 d-flex flex-column align-items-start">
                  <label
                    className="rp-returns-rma-modal-po-label"
                    htmlFor="poNumber"
                  >
                    {t('myReturns.pONumber')} ({t('common.optional')} )
                  </label>
                  <input
                    id="poNumber"
                    type="text"
                    onChange={handleChangePoNumber}
                    value={poNumber}
                    className="rp-returns-rma-modal-po-input"
                    maxLength={15}
                  />
                </div>
              </div>
            </div>

            {shippingTabToShow && rmaModalData.action !== RMA_EDIT && 
            <div className="return-shipping-row">
              <div className="col">
                <div className="rp-return-details-desktop--tabs-container-rma-modal">
                  <div className="rp-tabs">
                  <div className="rp-return-tabs--tab-rma-modal">
                      <div>{tabTitle}</div>
                      <div className="tab-back-btn-text" onClick={handleBackButtion}>{tabBackButtonText}</div>
                    </div>
                      <div className="rp-tabs--content">
                        <div className="rp-pick-up-tab--info">
                          <div className="return-shipping-container">
                            {checkShippingOtiopn &&  
                              <ShippingOptions
                                shippingSelectedOption={shippingSelectedOption}
                                handleShippingChangeOption={handleShippingChangeOption}
                                rmaSelected={rmaSelected}
                            />
                            }

                            {shippingSelectedOption==="shipToDistribution" && 
                              <DistributionOptions
                                distributionSelectedOption={distributionSelectedOption}
                                handleDistributionChangeOption={handleDistributionChangeOption}
                                rmaSelected={rmaSelected}
                            />
                            }

                            {shippingSelectedOption==="dropOffAtStore" && 
                              <DropOffStore
                                distributionSelectedOption={distributionSelectedOption}
                                handleDistributionChangeOption={handleDistributionChangeOption}
                                rmaSelected={rmaSelected}
                                storeList={storeList}
                                isLoading={isLoader}
                                handleDropOffWarehouse={handleDropOffWarehouse}
                              />
                            }



                            {distributionSelectedOption==="purchasePrepaidShipping" && confirmBox===false && 
                              <BoxInfo
                                distributionSelectedOption={distributionSelectedOption}
                                handleDistributionChangeOption={handleDistributionChangeOption}
                                rmaSelected={rmaSelected}
                                handleGenerateShippingLabel={handleGenerateShippingLabel}
                                userData={userData}
                                totalItemPrice={totalItemPrice}
                                upsErrorMessage={upsErrorMessage}
                                isLoader={isLoader}
                                shippingType={shppingTypeVal}
                                handleConfirmationCancel={handleConfirmationCancel}
                                handleBoxeChange={handleBoxeChange}
                              />
                            }

                            {confirmBox && 
                              <BoxConfirm
                                  distributionSelectedOption={distributionSelectedOption}
                                  handleDistributionChangeOption={handleDistributionChangeOption}
                                  rmaSelected={rmaSelected}
                                  handleGenerateShippingLabel={handleGenerateShippingLabel}
                                  boxResponseData={upsResponseData}
                                  totalShippingCharge={upsTotalShippingCharge}
                                  handleConfirmationCancel={handleConfirmationCancel}
                                  handleUpsConfirmation={handleUpsConfirmation}
                                  shippingType={shppingTypeVal}
                                  totalItemPrice={totalItemPrice}
                              />
                            }

                             {distributionSelectedOption==="selfShipping" && 
                              <SelfShipping
                                distributionSelectedOption={distributionSelectedOption}
                                handleDistributionChangeOption={handleDistributionChangeOption}
                                rmaSelected={rmaSelected}
                                storeList={storeList}
                                isLoading={isLoader}
                                handleSelfShippingWarehouse={handleSelfShippingWarehouse}
                              />
                            }
                          
                          </div>
                          
                        </div>
                       
                      </div>
                    </div>
                  </div>
                </div>
            </div>
            }
            

            <div className="rp-returns-rma-modal-actions">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12 d-flex justify-content-end">
                    <Button
                      action={handleCloseModal}
                      buttonClass="rp-returns-rma-modal-button outlined"
                      label={t('common.goBack')}
                      textTransform="uppercase"
                    />

                    {rmaModalData.action === RMA_SUBMIT ? (
                      <Button
                        action={handleSubmit}
                        buttonClass="rp-returns-rma-modal-button filled"
                        label={t('common.submitActionTxt')}
                        textTransform="uppercase"
                        disabled={isDisabledSubmit()}
                      />
                    ) : (
                      <Button
                        action={handleSave}
                        buttonClass="rp-returns-rma-modal-button filled"
                        label={t('common.save')}
                        textTransform="uppercase"
                        disabled={isDisabledSave()}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </Modal>
    </div>
  );
};

export default ReturnsRmaModal;
